export const logger = {
  // eslint-disable-next-line no-console
  debug: (...args) => {
    if (__DEBUG__) {
      console.groupCollapsed(...args)
      console.log(...args)
      console.trace()
      console.groupEnd()
    }
  },
  error: (error) => {
    if (error.message) {
      console.error(error.message)
    }
    if (error.response) {
      console.log(error.response.data)
      console.log(error.response.status)
      console.log(error.response.headers)
    } else if (error.request) {
      console.log(error.request)
    } else {
      console.error(error)
      console.dir(error)
    }
    if (error.config) {
      console.log(error.config)
    }
  }
}

const install = function (Vue) {
  Vue.prototype.$logger = logger
}

export default {
  logger,
  install
}
